import { ts } from '_core';

import { _ } from '@local/finsera-core';

import { DraftParams } from './types';

export const validate = (params: DraftParams) => {
  const errors = [];
  if (_.isNil(params.window)) errors.push('Window is required field.');
  return errors;
};

export const getName = (params: DraftParams) => {
  return `Specific Risk Distribution over Time - ${params.window} Day${params.window == 1 ? '' : 's'}`;
};

export type Tab = 'forecast' | 'realized' | 'diff';

export const transform = (data: ts.types.widgets.TableData, tab: Tab) => {
  const replacement = tab + '_';
  return data?.map((item) => {
    const newItem = { date: item.build_date } as ts.types.widgets.TableData[number];
    Object.keys(item).forEach((key) => {
      if (key !== 'date' && key.startsWith(tab)) {
        const quantile = key.replace(replacement, '');
        newItem[`${quantile}th Percentile`] = item[key];
      }
    });
    return newItem;
  });
};
